import { Check, Circle, PermPhoneMsgOutlined, SchoolOutlined } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Link, ListItem, ListItemText } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from "@mui/material/Button";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Collapse from '@mui/material/Collapse';
import Fab from "@mui/material/Fab";
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Rating from '@mui/material/Rating';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import orderBy from 'lodash.orderby';
import truncate from "lodash.truncate";
import { FC, useState } from 'react';
import { SocialIcon } from 'react-social-icons';
import { socialLinks } from '../../common/utils';
import { letterToColor } from '../../consts/colors';
import { UserInfo } from '../../consts/types/user';
import InviteCandidateDialog from './InviteCandidateDialog';



enum CardTabs {
    Education,
    Experience,
    Skills,
    Social,
    Recommenders,
}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledRating = styled(Rating)({
    gap: 2,
    '& .MuiRating-iconFilled': {
        color: '#1976d2',
    },
    '& .MuiRating-iconHover': {
        color: '#3390ed',
    },
});

interface CandidateCardProps {
    candidate: UserInfo;
}

type Props = CandidateCardProps;


const CandidateCard: FC<Props> = (props: Props) => {
    const { candidate } = props;
    const [expanded, setExpanded] = useState(false);
    const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
    const [tab, setTab] = useState(0);
    const [showMore, setShowMore] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const candidateAvatar = `${(candidate.name || candidate.email || "").split(' ')[0][0]}${((candidate.name || candidate.email || "").split(' ')[1] || [""])[0]}`;
    return <Card >
        <CardHeader
            avatar={
                <Avatar sx={{ bgcolor: letterToColor(candidateAvatar[0]) }} >
                    {candidateAvatar}
                </Avatar>
            }

            // <Badge  badgeContent={<Typography fontWeight="bold"  >95%</Typography>} color="success"/>
            title={candidate.name}
            action={<IconButton color="primary" sx={{ ml: 1, mr: 1, cursor: "pointer" }} onClick={() => { setInviteDialogOpen(true) }}>
                <PermPhoneMsgOutlined fontSize="medium" />

            </IconButton>}
            subheader={candidate.title || candidate.degrees?.join(",")}
            titleTypographyProps={{ fontSize: { xs: "1.1rem", md: "1.3rem" }, fontWeight: "bold" }}
            subheaderTypographyProps={{ fontSize: { xs: "0.85rem", md: "0.9rem" }, color: "#727070" }}
        />
        <CardContent>
            {candidate.description && <Typography fontSize={{ xs: "0.85rem", md: "0.9rem" }}
                mb={2} sx={{ whiteSpace: "break-spaces", wordBreak: "break-word" }}
            >
                {showMore ? candidate.description.trimEnd() : truncate(candidate.description, { length: 70 }).trimEnd()}
                {candidate.description.length > 70 && <Button size="small" sx={{ fontSize: { xs: "0.6rem", md: "0.65rem" }, fontWeight: "bold" }} color="inherit" onClick={() => { setShowMore(!showMore) }}>
                    {showMore ? "show less" : "show more"}
                </Button>}
            </Typography>}
            <Box display="flex" gap={{ xs: 1, md: 4 }} flexDirection={{ xs: "column", md: "row" }} >
                {candidate.management && <Box display="flex" alignItems="center" color="#08346a">
                    <Check sx={{ mr: 1 }} color="inherit" fontSize='small' />
                    <Typography fontSize="0.85rem" color="inherit">
                        Management Experience
                    </Typography>
                </Box>}
                {candidate.startup && <Box display="flex" alignItems="center" color="#08346a">
                    <Check sx={{ mr: 1 }} color="inherit" fontSize='small' />
                    <Typography fontSize="0.85rem" color="inherit" >
                        Startup Experience
                    </Typography>
                </Box>}
            </Box>

            {/* {candidate.testGrade && <Typography variant="body2" >
                <span style={{ fontWeight: 500 }}>Skills Test Grade</span>&nbsp;&nbsp;&nbsp;
                {`${candidate.testGrade || 0}%`}
            </Typography>} */}
            {/* <Box display="flex" gap={1} mt={3} flexWrap="wrap">
                {candidate.skills?.map(skill => <Chip key={skill.skill} color="info" size="small" label={skill.skill} variant="outlined" />)}
            </Box> */}

        </CardContent>
        <CardActions disableSpacing >
            <Box display="flex" alignItems="center" ml={1}>
                {/* <WorkHistoryOutlined color="inherit" sx={{ mr: 1 }} /> */}
                {candidate.experienceYears > 0 && <Typography fontSize="0.85rem" >
                    <span style={{ fontWeight: 500 }}>Experience Years</span>&nbsp;&nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>{`${candidate.experienceYears}`}</span>
                </Typography>}
            </Box>
            {/* <Button  variant="outlined" size="small" sx={{ ml: 1, }} onClick={() => { setInviteDialogOpen(true) }}>
                <ContactMail sx={{ mr: 1 }} />
                Contact
            </Button> */}
            {/* {candidate.approved && <Box display="flex" alignItems="center" ml={4} fontSize="1rem">
                <CheckCircle color="success" fontSize="inherit" />
                <Typography sx={{ ml: 0.5, color: "#2e7d32" }} fontSize="0.8rem" >Approved</Typography>
            </Box>}
            {!candidate.approved && <Box display="flex" alignItems="center" ml={1} fontSize="1rem" color="#f8ad70">
                <Warning color="inherit" fontSize="inherit" />
                <Typography sx={{ ml: 0.5, color: "#f8ad70" }} fontSize="0.8rem" >Not Approved Yet</Typography>
            </Box>} */}
            {/* <ExpandMore
                expand={false}
                onClick={handleExpandClick}
                // aria-expanded={expanded}
                // aria-label="show more"
            >
                <ExpandMoreIcon color="action" />
               
            </ExpandMore> */}
            <Fab variant="extended" onClick={handleExpandClick} color="primary" size="small" style={{ marginLeft: 'auto', margin: '8px 8px 8px auto' }}  >
                {expanded ? 'Less details' : 'Show details'}
            </Fab>

        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
                <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2.5 }} variant="scrollable" scrollButtons="auto">
                    {Object.entries(CardTabs).filter(([key, value]) => isNaN(Number(key))).map(([key, value]) => {
                        // if (value === CardTabs.General && !candidate.largeCompanies && !candidate.management && !candidate.startup) {
                        //     return null;
                        // }
                        return <Tab key={key} label={key} value={value} />
                    })}
                </Tabs>
                {/* {tab === CardTabs.General && <Box p={{ xs: 0, md: 2 }} pt={"0 !important"} minHeight="170px" display="flex" gap={3} flexDirection={{ xs: "column", md: "row" }}> */}
                {/* <Box display="flex" flexDirection="column" flex={1}> */}
                {/* <FormGroup >
                            {candidate.largeCompanies && <FormControlLabel sx={{ mb: 1, fontSize: { xs: "0.9rem", md: "1rem" } }} control={<Checkbox checked size='small' />} label={<Typography sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}>Large Companies Experience</Typography>} />}
                            {candidate.startup && <FormControlLabel sx={{ mb: 1, fontSize: { xs: "0.9rem", md: "1rem" } }} control={<Checkbox checked size='small' />} label={<Typography sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}>Startup Experience</Typography>} />}
                            {candidate.management && <FormControlLabel control={<Checkbox checked size='small' />} label={<Typography sx={{ mb: 1, fontSize: { xs: "0.9rem", md: "1rem" } }}>Management Experience</Typography>} />}
                        </FormGroup> */}
                {/* {candidate.salary && <Typography sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }} ><span style={{ fontWeight: 500 }}>Salary Expectations</span> &nbsp;&nbsp; {candidate.salary}</Typography>} */}
                {/* </Box> */}
                {/* </Box>} */}
                {tab === CardTabs.Social && <Box p={{ xs: 0, md: 2 }} pt={"0 !important"} minHeight="170px" display="flex" gap={3} flexDirection={{ xs: "column", md: "row" }}>
                    <Box display="flex" flexDirection="column" flex={1} gap={2}>
                        {candidate.social?.map(so => <Card key={so.link} variant="outlined">
                            <CardContent >
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Link color="primary" href={so.link} rel="noreferrer"
                                        fontWeight={400}
                                        target="_blank"
                                        textTransform="capitalize"
                                        display="flex"
                                        alignItems="center"
                                        fontSize={{ xs: "1rem", md: "1.1rem" }} >
                                        <SocialIcon url={so.link} style={{ marginRight: "5px", height: 26, width: 26 }} />
                                        {socialLinks.detectProfile(so.link)}
                                    </Link>
                                </Box>
                            </CardContent>
                        </Card>)}
                    </Box>
                </Box>}
                {tab === CardTabs.Experience && <Box p={{ xs: 0, md: 2 }} minHeight="170px" pt={"0 !important"}>
                    <Timeline sx={{
                        padding: 0,
                        [`& .${timelineItemClasses.root}:before`]: {
                            flex: 0,
                            padding: 0,
                        },
                    }}>
                        {orderBy(candidate.experience, [exp => "a" + exp.fromYear, exp => exp.toYear === -1 ? "current" : "a" + exp.toYear], ["desc", "desc"]).map((exp, index) => <TimelineItem key={exp.companyName + index}>
                            <TimelineSeparator>
                                <TimelineDot color="primary" variant='outlined' />
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent sx={{ paddingRight: 0 }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" >
                                    <Typography fontWeight={500} fontSize={{ xs: "0.95rem", md: "1rem" }}>{exp.companyName}</Typography>
                                </Box>
                                <Typography fontSize={{ xs: "0.875rem", md: "0.95rem" }} color="GrayText" mb={0.5}>{exp.role}</Typography>
                                <Typography fontSize={{ xs: "0.875rem", md: "0.95rem" }} color="GrayText">{`${exp.fromYear} - ${exp.toYear === -1 ? "current" : exp.toYear}`}</Typography>
                                {/* {exp.document && <Typography fontSize={{ xs: "0.7rem", md: "0.875rem" }} color="GrayText">{exp.document}</Typography>} */}
                            </TimelineContent>
                        </TimelineItem>
                        )}

                    </Timeline>

                </Box>}
                {tab === CardTabs.Education && <Box p={{ xs: 0, md: 2 }} minHeight="170px" pt={"0 !important"}>
                    {orderBy(candidate.education, [edu => "a" + edu.fromYear, edu => edu.toYear === -1 ? "current" : "a" + edu.toYear], ["desc", "desc"]).map((edu, index) => <Card key={edu.school + index} sx={{ mt: 2 }} variant="outlined">
                        <CardContent >
                            <Box display="flex" alignItems="center">
                                <SchoolOutlined fontSize="small" sx={{ mr: 2 }} color="primary" />
                                <Typography color="text.primary" fontWeight={500} fontSize={{ xs: "0.95rem", md: "1rem" }} component="div">
                                    {edu.school}
                                </Typography>
                            </Box>
                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.9rem !important" }} pl={4.6} >
                                {`${edu.degree} `}
                                {edu.grade > 0 && <Box display="inline" color="#999b9e" fontSize={{ xs: "0.45rem !important", md: "0.55rem !important" }}><Circle fontSize='inherit' color="inherit" /></Box>}
                                {edu.grade > 0 && ` ${edu.grade}`}
                            </Typography>
                            <Typography color="text.secondary" mt={0.2} fontSize={{ xs: "0.8rem !important", md: "0.9rem !important" }} pl={4.6}>
                                {`${edu.fromYear} - ${edu.toYear === -1 ? "current" : edu.toYear}`}
                            </Typography>
                            {/* {edu.document && <Typography mt={1} color="text.secondary" fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                                {edu.document}
                            </Typography>} */}

                        </CardContent>
                    </Card>)}
                </Box>}
                {tab === CardTabs.Skills && <Box p={{ xs: 0, md: 2 }} minHeight="170px" pt={"0 !important"} display="flex" flexWrap="wrap" gap={1}>
                    {orderBy(candidate.skills, skill => skill.skill).map((skill, index) => <ListItem key={skill.skill + index} sx={{ display: "flex", flex: { xs: "0 0 47%", md: "0 0 22%" }, maxHeight: "50px", background: "#f8fbff" }}>
                        {/* <ListItemIcon sx={{ fontSize: "0.85rem", minWidth: "25px", color: "black" }}>
                            <MinimizeOutlined fontSize="inherit" color="inherit" />
                        </ListItemIcon> */}
                        <ListItemText primary={skill.skill} secondary={`${skill.years} years`}
                            primaryTypographyProps={{ fontWeight: 500, fontSize: { xs: "0.9rem", md: "0.95rem" }, whiteSpace: "nowrap" }}
                        />

                    </ListItem>)}
                </Box>}
                {tab === CardTabs.Recommenders && <Box p={{ xs: 0, md: 2 }} minHeight="170px" pt={"0 !important"}>
                    {candidate.recommenders?.map((rec, index) => <Card key={rec.email + index} sx={{ mt: 2 }} variant="outlined">
                        <CardContent >
                            <Box display="flex" alignItems="center">
                                <Typography color="primary" fontWeight={400} fontSize={{ xs: "1rem", md: "1.1rem" }} component="div">
                                    {rec.name}
                                </Typography>
                            </Box>
                            {rec.role && <Typography fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} >
                                {rec.role}
                            </Typography>}
                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} mt={2}>
                                {rec.email}
                            </Typography>
                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} >
                                {rec.phone}
                            </Typography>

                            {/* <Typography fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} mt={2} >
                                {rec.recommendation || "Recommendation not given yet"}
                            </Typography> */}

                        </CardContent>
                    </Card>)}
                </Box>}
            </CardContent>
        </Collapse>
        <InviteCandidateDialog open={inviteDialogOpen} candidate={candidate}
            onClose={() => { setInviteDialogOpen(false) }} />
    </Card >;
}


export default CandidateCard;

